let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("PAD2J")).then(() => parcelRequire('6UEa7'));